import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPasswordExpired, selectToken } from "./store/authSlice";

// Login page only. Already signed in? Skip it — but an expired password
// still has to go through /reset-password first, not straight to /home.
export default function PublicRoute() {
    const token = useSelector(selectToken);
    const passwordExpired = useSelector(selectPasswordExpired);

    if (token) return <Navigate to={passwordExpired ? "/reset-password" : "/home"} replace />;
    return <Outlet />;
}